import { gridEdgeScatter, edgeScatter } from '../helpers-board.js';

function animateButtons({ board, buttons, registerCleanup }) {
  board.classList = "board composite-transform disco";
  board.style = "";
  // gridEdgeScatter({ board });
  edgeScatter({ board, buttons });
  // console.log("animateButtons?");
  // console.log({ board, buttons });
  // board.classList.add("minify");
  let start;
  let lastTime = 0;
  let done;
  let animationId;
  const delay = 20;
  const edgeCooldown = 200; //minimum milliseconds before adjusting again for edge hit
  const collisionCooldown = 500; //minimum milliseconds before adjusting again for button hit
  const maxSpeed = 8;
  const movingButtons = [];
  const boardRect = board.getBoundingClientRect();
  const boardYOffset = board.getBoundingClientRect().top;
  const edges = { right: window.innerWidth, bottom: window.innerHeight };
  const discoballDiv = document.createElement("div");
  discoballDiv.classList.add("discoball");
  document.body.appendChild(discoballDiv);


  function cleanup() {
    // if (e.target.tagName !== 'BUTTON') return;
    board.classList.remove('disco');
    window.cancelAnimationFrame(animationId)
    document.body.removeChild(discoballDiv);
  }

  // setTimeout(() => { board.addEventListener("click", cleanup) }, 1);
  registerCleanup(cleanup);

  // Setup
  buttons.forEach((button) => {
    button.style.transition = 'top 0ms, left 0ms';
    button.style.transform = '';

    // Stop animation on any button press
    // TODO: Change to cleanup method
    // button.addEventListener('click', () => { done = true; window.cancelAnimationFrame(animationId) });

    const buttonRect = button.getBoundingClientRect();

    //Setup button variables
    movingButtons.push({
      el: button,
      posX: buttonRect.left,
      posY: buttonRect.top - boardYOffset,
      speedX: (Math.random() - 0.5) * 2 * maxSpeed,
      speedY: (Math.random() - 0.5) * 2 * maxSpeed,
      lastEdgeCollision: 0,
      buttonCollisions: new Map(),
    });


  });

  function step(currentTime) {
    // console.log(`current time: ${currentTime} \t start: ${start} \t lastTime: ${lastTime}`);
    if (start === undefined) {
      start = currentTime
    }

    if (lastTime + delay <= currentTime && !done) {
      movingButtons.forEach((mover, i) => {

        mover.posX += mover.speedX;
        mover.posY += mover.speedY;

        let bounds = mover.el.getBoundingClientRect();

        //Check edge collision
        if (mover.posX <= 0) {
          mover.posX = 0;
          if (currentTime - mover.lastEdgeCollision > edgeCooldown) {
            mover.speedX *= -1;
            mover.lastEdgeCollision = currentTime;
          }
        }

        if (mover.posX >= edges.right - bounds.width) {
          mover.posX = edges.right - bounds.width;
          if (currentTime - mover.lastEdgeCollision > edgeCooldown) {
            mover.speedX *= -1;
            mover.lastEdgeCollision = currentTime;
          }
        }

        if (mover.posY <= 0) {
          mover.posY = 0;
          if (currentTime - mover.lastEdgeCollision > edgeCooldown) {
            mover.speedY *= -1;
            mover.lastEdgeCollision = currentTime;
          }
        }

        if (mover.posY >= edges.bottom - bounds.height) {
          mover.posY = edges.bottom - bounds.height;
          if (currentTime - mover.lastEdgeCollision > edgeCooldown) {
            mover.speedY *= -1;
            mover.lastEdgeCollision = currentTime;
          }
        }

        movingButtons.forEach((otherMover, j) => {
          if (mover.el === otherMover.el) return;
          const otherBounds = otherMover.el.getBoundingClientRect();

          // Check for collision
          if (
            bounds.right > otherBounds.left &&
            bounds.left < otherBounds.right &&
            bounds.bottom > otherBounds.top &&
            bounds.top < otherBounds.bottom
          ) {
            const lastCollision = mover.buttonCollisions.get(j) || 0;
            if (currentTime - lastCollision > collisionCooldown) {
              mover.speedX *= -1;
              mover.speedY *= -1;
              otherMover.speedX *= -1;
              otherMover.speedY *= -1;
              // resolveOverlap(mover, otherMover);
              mover.buttonCollisions.set(j, currentTime);
              otherMover.buttonCollisions.set(i, currentTime);
            }
          }

        });

        mover.el.style.left = `${mover.posX}px`;
        mover.el.style.top = `${mover.posY - boardYOffset}px`;

        lastTime = currentTime;
      });
    }


    if (!done) {
      animationId = window.requestAnimationFrame(step);
    }
  }

  animationId = window.requestAnimationFrame(step);
}

// function getXMidpoint(btn1, btn2) {
//   return (btn1.style.right - btn2.style.left) / 2;
// }
//
// function getYMidpoint(btn1, btn2) {
//   return (btn1.style.bottom - btn2.style.top) / 2;
// }


function resolveOverlap(mover, otherMover) {
  const bounds = mover.el.getBoundingClientRect();
  const otherBounds = otherMover.el.getBoundingClientRect();

  // Compute overlap distances in X and Y
  const dx = Math.min(bounds.right, otherBounds.right) - Math.max(bounds.left, otherBounds.left);
  const dy = Math.min(bounds.bottom, otherBounds.bottom) - Math.max(bounds.top, otherBounds.top);

  // Move mover out along the larger overlap axis
  if (dx < dy) {
    mover.posX += mover.speedX > 0 ? dx : -dx;
    otherMover.posX -= mover.speedX > 0 ? dx : -dx;
  } else {
    mover.posY += mover.speedY > 0 ? dy : -dy;
    otherMover.posY -= mover.speedY > 0 ? dx : -dx;
  }
  // Update style
  mover.el.style.left = `${mover.posX}px`;
  mover.el.style.top = `${mover.posY}px`;
}

function animateButtonsHelper() {
  window.requestAnimationFrame(animateButtons);
}



export default animateButtons;
